import React from 'react'
import HeroHeadline from '../../Components/HeroHeadline'
import { Box } from '@mui/material'
import Testimonial from '../Dashboard/Testimonial'
import AllServices from './AllServices'
import WorkingProcess from './WorkingProcess'
import Mentoring from './ServicesDetails/MentoringService/MentoringTabs'
import { aboutbg2, aboutbg3, outline4 } from '../../assets'
import Banner from './Banner'


const Services:React.FC = () => {
  return (
    <Box>
         {/* <HeroHeadline backgroundImage={aboutbg3} >
            <span data-highlight>Sales mentoring </span>{" "}
           <span data-outline>with a strong focus on</span>{" "}
      
            <span data-highlight>Branding</span>
          </HeroHeadline> */}
          <Banner/>
          <AllServices/>
          <Testimonial/>
          <WorkingProcess/>
          {/* <ClientsLogo/> */}
      
    </Box>
  )
}

export default Services
